<template>
  <div>
    <router-view :key="$route.fullPath"></router-view>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <h4 class="title"></h4>
          <div class="is-mobile">
             <router-link to="/season-totals/team-select" class="button is-success">Back to Teams</router-link>
         </div>
          <div class="columns is-mobile">
            <div class="title is-child  is-vertical" style="margin:0 auto" >
                <img class="player_icon" style="margin:0 auto;display:block;" :src="Faceoffs.team.logo"><h1 class="title"> {{Faceoffs.team.name}} Stats</h1>
            </div>
          </div>
           <div class="columns is-mobile">
            <div class="is-child  is-vertical" style="margin:25px auto">
                <p> <b>Latest Updates:<br />Load time increase due to render of heatmaps!?<br />Added Faceoff PvP<br />Added Graphs for each segment<br />Added basic map controls - Shot type, Period, Shot Size</b></p>
          </div>
          </div>
               <div class="tile is-parent is-12 is-vertical">
                <article class="tile is-child box">
                  <section class="hero is-dark bold">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Faceoffs</h1> 
                         <button @click='toggleFaceoffs()' class="button is-default" style="margin:0 80%;">Show / Hide</button>
                        </div>
                    </div>
                  </section>
                <div class="faceoffs" v-show="isFaceoffOpen">
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                        Teams Totals <p class="subtitle">Wins - Losses</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'doughnut'" :data="fo_total_chart" :options="fo_total_options" style="max-width:50%;height=400px;margin:0 auto;"></chart>
                    </article>
                  </div>
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>FOT</th>
                        <th>FOW</th>
                        <th>FOL</th>
                        <th>FOW%</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{this.Faceoffs.total_taken}}</td>
                          <td>{{this.Faceoffs.total_wins}}</td>
                          <td>{{this.Faceoffs.total_losses}}</td>
                          <td>{{this.Faceoffs.total_win_percent}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Team By Lane <p class="subtitle">Left - Center - Right</p></h1> 
                      </div>
                    </div>
                  </section>                  
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'doughnut'" :data="fo_total_lane_chart" :options="fo_total_options" style="max-width:50%;height=400px;margin:0 auto;"></chart>
                    </article>
                  </div>
                  <div class="">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Location</th>
                        <th>FOT</th>
                        <th>FOW</th>
                        <th>FOW%</th>
                        <th>FOL</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Left</td>
                          <td>{{this.Faceoffs.taken_left}}</td>
                          <td>{{this.Faceoffs.wins_left}}</td>
                          <td>{{this.Faceoffs.wins_left_percent}}</td>
                          <td>{{this.Faceoffs.losses_left}}</td>
                        </tr>
                        <tr>
                          <td>Center</td>
                          <td>{{this.Faceoffs.taken_center}}</td>
                          <td>{{this.Faceoffs.wins_center}}</td>
                          <td>{{this.Faceoffs.wins_center_percent}}</td>
                          <td>{{this.Faceoffs.losses_center}}</td>
                        </tr>
                        <tr>
                          <td>Right</td>
                          <td>{{this.Faceoffs.taken_right}}</td>
                          <td>{{this.Faceoffs.wins_right}}</td>
                          <td>{{this.Faceoffs.wins_right_percent}}</td>
                          <td>{{this.Faceoffs.losses_right}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Player Totals</h1> <p class="subtitle">Taken - Wins - Losses - Win %</p>
                      </div>
                    </div>
                  </section>                    
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="fo_player_series" :options="bar_options" style=""></chart>
                    </article>
                  </div>
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>FOT</th>
                        <th>FOW</th>
                        <th>FOL</th>
                        <th>FOW%</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in this.Faceoffs.players">
                          <td>{{player.player_id}}</td>
                          <td>{{player.player_fot}}</td>
                          <td>{{player.player_fow}}</td>
                          <td>{{player.player_fol}}</td>
                          <td>{{player.player_fow_percent}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Player By Lane <p class="subtitle">Left - Center - Right</p></h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="fo_player_lane" :options="bar_options" style=""></chart>
                    </article>
                  </div>
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>FOT</th>
                        <th>Left</th>
                        <th>%</th>
                        <th>Center</th>
                        <th>%</th>
                        <th>Right</th>
                        <th>%</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in this.Faceoffs.players">
                          <td>{{player.player_id}}</td>
                          <td>{{player.player_fot}}</td>
                          <td>{{player.player_lane_left_wins}} of {{player.player_lane_left_taken}}</td>
                          <td>{{player.player_lane_left_percent}}</td>
                          <td>{{player.player_lane_center_wins}} of {{player.player_lane_center_taken}}</td>
                          <td>{{player.player_lane_center_percent}}</td>
                          <td>{{player.player_lane_right_wins}} of {{player.player_lane_right_taken}}</td>
                          <td>{{player.player_lane_right_percent}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Player By Zone<p class="subtitle">Offensive - Neutral - Defensive</p></h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="fo_player_zone" :options="bar_options" style=""></chart>
                    </article>
                  </div>  
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>FOT</th>
                        <th>Offensive</th>
                        <th>%</th>
                        <th>Neutral</th>
                        <th>%</th>
                        <th>Defensive</th>
                        <th>%</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in this.Faceoffs.players">
                          <td>{{player.player_id}}</td>
                          <td>{{player.player_fot}}</td>
                          <td>{{player.player_zone_offensive_wins}} of {{player.player_zone_offensive_taken}}</td>
                          <td>{{player.player_zone_offensive_percent}}</td>
                          <td>{{player.player_zone_neutral_wins}} of {{player.player_zone_neutral_taken}}</td>
                          <td>{{player.player_zone_neutral_percent}}</td>
                          <td>{{player.player_zone_offensive_wins}} of {{player.player_zone_defensive_taken}}</td>
                          <td>{{player.player_zone_defensive_percent}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Player By Situation<p class="subtitle">Even Handed - Power Play - Short Handed</p></p></h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="fo_player_situation" :options="bar_options" style=""></chart>
                    </article>
                  </div>  
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>FOT</th>
                        <th>Even Handed</th>
                        <th>%</th>
                        <th>Power Play</th>
                        <th>%</th>
                        <th>Short Handed</th>
                        <th>%</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in this.Faceoffs.players">
                          <td>{{player.player_id}}</td>
                          <td>{{player.player_situation_fot}}</td>
                          <td>{{player.player_situation_eh_wins}} of {{player.player_situation_eh_taken}}</td>
                          <td>{{player.player_situation_eh_percent}}</td>
                          <td>{{player.player_situation_pp_wins}} of {{player.player_situation_pp_taken}}</td>
                          <td>{{player.player_situation_pp_percent}}</td>
                          <td>{{player.player_situation_sh_wins}} of {{player.player_situation_sh_taken}}</td>
                          <td>{{player.player_situation_sh_percent}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Player Vs Player<p class="subtitle">Wins/Losses Lanes</p></h1>
                        <button @click='toggleFaceoffsPvp()' class="button is-default" style="margin:0 80%;">Show / Hide</button>
                      </div>
                    </div>
                  </section>
                  <div v-show="isFaceoffsPvp">
                    <div v-for="player in this.Faceoffs.players">
                      <div class="column" style="margin:0 auto;">
                      <h1 class="title">{{player.player_id}}</h1>
                      </div>
                      <div class="block content">
                        <table class="table is-responsive">
                          <thead>
                            <th>Vs Player</th>
                            <th>FOT</th>
                            <th>Wins</th>
                            <th>%</th>
                            <th>Left</th>
                            <th>Center</th>
                            <th>Right</th>
                          </thead>
                          <tbody>
                            <tr v-for="away_player in player.player_vs_player">
                              <td>{{away_player.away_player_id}}</td>
                              <td>{{away_player.taken}}</td>
                              <td>{{away_player.wins}}</td>
                              <td>{{away_player.win_percent}}</td>
                              <td>{{away_player.leftWins}} of {{away_player.leftTaken}}</td>
                              <td>{{away_player.centerWins}} of {{away_player.centerTaken}}</td>
                              <td>{{away_player.rightWins}} of {{away_player.rightTaken}}</td>
                              </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  </div>
                </article>

                <article class="tile is-child box">
                  <section class="hero is-dark bold">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Shots</h1> 
                        </div>
                    </div>
                   </section>
                    <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                        Teams Totals <p class="subtitle">On Net - Missed Net - Blocked - Avgerage / Games Played</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                   <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'doughnut'" :data="so_total_chart" :options="fo_total_options" style="max-width:50%;height=400px;margin:0 auto;"></chart>
                    </article>
                  </div>
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Team</th>
                        <th>Total</th>
                        <th>On Net</th>
                        <th>Missed Net</th>
                        <th>Blocked</th>
                        <th>Avg total shots per game</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Cardiff Devils</td>
                          <td>{{this.Shots.home_total}}</td>
                          <td>{{this.Shots.home_total_on_net}}</td>
                          <td>{{this.Shots.home_total_missed_net}}</td>
                          <td>{{this.Shots.home_total_blocked}}</td>
                          <td>{{this.Shots.average_total_home}}</td>
                        </tr>
                        <tr>
                          <td>{{this.Faceoffs.team.name}}</td>
                          <td>{{this.Shots.away_total}}</td>
                          <td>{{this.Shots.away_total_on_net}}</td>
                          <td>{{this.Shots.away_total_missed_net}}</td>
                          <td>{{this.Shots.away_total_blocked}}</td>
                          <td>{{this.Shots.average_total_away}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div id="away-shots">
                      <section class="hero is-light">
                      <div class="hero-body">
                        <div class="container">
                          <h1 class="title">
                          Shotmaps <p class="subtitle">All shots, all situations / All shots Powerplay (our Pk)</p>
                          </h1>
                        </div>
                      </div>
                    </section>
                    <div class="child is-box box">
                      <div class="column">
                        <p class="bold-el">Map Controls</p>
                      </div>
                      <div class="columns">
                        <div class="column is-2">
                          <div class="control">
                            <select class="select" v-model="selected"  v-on:change="updateHeatmaps()">
                              <option v-for="option in options" v-bind:value="option.value">
                              {{ option.text }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="column is-2">
                          <div class="control">
                          <select class="select" v-model="periodSelect"  v-on:change="updateHeatmaps()">
                            <option v-for="pOption in periodOptions" v-bind:value="pOption.value">
                            {{ pOption.text }}
                            </option>
                          </select>
                          </div>
                        </div>
                        <div class="column is-6">
                          <div class="block styles-box">
                            <p><b>Heatmap size:</b></p>
                            <p>
                              <slider @change="updateHeatmapSize" type="primary" :value="10" :max="24" :min="5" :step="2" class="slider is-primary"></slider>
                            </p>
                          </div>
                        </div>
                      </div>
                      </div>
                    <div class="columns is-6">

                        <div class="column">
                          <h1 class="title">Cardiff Devils - All shots</h1>
                          <canvas class="is-canvas-responsive" ref="home_shots_canvas" width="600" height="530" style="background: url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"></canvas>
                        </div>
                        <div class="column">
                          <h1 class="title">{{this.Faceoffs.team.name}} - All shots</h1> 
                          <canvas  class="is-canvas-responsive" ref="away_shots_canvas" width="600" height="530" style="background: url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"></canvas>
                        </div>
                      </div>
                       <div class="columns is-6">
                        <div class="column">
                          <h1 class="title">Cardiff Devils - Power Play</h1>
                          <canvas   class="is-canvas-responsive" ref="home_shots_canvas_pp" width="600" height="530" style="background: url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"></canvas>
                        </div>
                        <div class="column">
                          <h1 class="title">{{this.Faceoffs.team.name}} - Power Play</h1> 
                          <canvas   class="is-canvas-responsive" ref="away_shots_canvas_pp" width="600" height="530" style="background: url('https://devils.roblutken.com/devils/assets/shotmap_output.png')"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                    <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                        Player Totals <p class="subtitle">On Net - Missed Net - Blocked - Avgerage / Games Played</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="shot_player_totals" :options="bar_options" style=""></chart>
                    </article>
                  </div>
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>Total</th>
                        <th>On Net</th>
                        <th>Missed Net</th>
                        <th>Blocked</th>
                        <th>Avg / Game</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in this.Shots.home_players">
                            <td>{{player.player_id}}</td>
                            <td>{{player.player_total}}</td>
                            <td>{{player.player_on_net}}</td>
                            <td>{{player.player_missed_net}}</td>
                            <td>{{player.player_blocked}}</td>
                            <td>{{player.player_avg_game}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                    <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                       Against Player Totals <p class="subtitle">On Net - Missed Net - Blocked - Avgerage / Games Played</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="shot_away_player_totals" :options="bar_options" style=""></chart>
                    </article>
                  </div>                  
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>Total</th>
                        <th>On Net</th>
                        <th>Missed Net</th>
                        <th>Blocked</th>
                        <th>Avg / Game</th>
                      </thead>
                      <tbody>
                             <tr v-for="player in this.Shots.away_players">
                            <td>{{player.player_id}}</td>
                            <td>{{player.player_total}}</td>
                            <td>{{player.player_on_net}}</td>
                            <td>{{player.player_missed_net}}</td>
                            <td>{{player.player_blocked}}</td>
                            <td>{{player.player_avg_game}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                    <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                       Home Situational  <p class="subtitle">Power Play On Net - Short Handed On Net</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="shot_player_situational" :options="bar_options" style=""></chart>
                    </article>
                  </div>                         
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>Power Play On Net</th>
                        <th>Short Handed On Net</th>
                      </thead>
                      <tbody>
                         <tr v-for="player in this.Shots.home_players">
                            <td>{{player.player_id}}</td>
                            <td>{{player.player_pp_on_net}}</td>
                            <td>{{player.player_sh_on_net}}</td>
                          </tr>
                      </tbody>
                    </table>
                  </div>
                    <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                       Away Situational <p class="subtitle">Power Play On Net - Short Handed On Net</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="shot_away_player_situational" :options="bar_options" style=""></chart>
                    </article>
                  </div>
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>Power Play On Net</th>
                        <th>Short Handed On Net</th>
                      </thead>
                      <tbody>
                         <tr v-for="player in this.Shots.away_players">
                            <td>{{player.player_id}}</td>
                            <td>{{player.player_pp_on_net}}</td>
                            <td>{{player.player_sh_on_net}}</td>
                          </tr>
                      </tbody>
                    </table>
                  </div>
                </article>
                <article class="tile is-child box">
                   <section class="hero is-dark bold">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Turnovers</h1> </div>
                    </div>
                   </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'doughnut'" :data="to_totals" :options="fo_total_options" style="max-width:50%;height=400px;margin:0 auto;"></chart>
                    </article>
                  </div>                          
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                       Team totals<p class="subtitle">Offensive - Neutral - Defensive - Average / Game</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="block content">
                    <table class="table is-responsive">
                      <thead>
                        <th>Total</th>
                        <th>Offensive</th>
                        <th>Neutral</th>
                        <th>Defensive</th>
                        <th>Avg total turnovers per game</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{this.Turnovers.home_total}}</td>
                          <td>{{this.Turnovers.home_total_offensive}}</td>
                          <td>{{this.Turnovers.home_total_neutral}}</td>
                          <td>{{this.Turnovers.home_total_defensive}}</td>
                          <td>{{this.Turnovers.average_total_home}}</td>
                        </tr>
                      </tbody>
                     </table>
                  </div>                

                    <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                        Player Totals <p class="subtitle">Offensive - Neutral - Defensive - Avgerage / Games Played</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="to_player_totals" :options="bar_options" style=""></chart>
                    </article>
                  </div>                  
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>Total</th>
                        <th>Offensive</th>
                        <th>Neutral</th>
                        <th>Defensive</th>
                        <th>Avg / Game</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in this.Turnovers.home_players">
                            <td>{{player.player_id}}</td>
                            <td>{{player.player_total}}</td>
                            <td>{{player.player_offensive}}</td>
                            <td>{{player.player_neutral}}</td>
                            <td>{{player.player_defensive}}</td>
                            <td>{{player.player_avg_game}}</td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                   <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                        Situational Player Totals <p class="subtitle"> PP / SH Total - Offensive - Neutral - Defensive </p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="to_player_situational" :options="bar_options" style=""></chart>
                    </article>
                  </div>                         
                  <div id="pp" class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>PP Total</th>
                        <th>PP Offensive</th>
                        <th>PP Neutral</th>
                        <th>PP Defensive</th>
                        <th>SH Total</th>
                        <th>SH Offensive</th>
                        <th>SH Neutral</th>
                        <th>SH Defensive</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in this.Turnovers.home_players">
                            <td>{{player.player_id}}</td>
                            <td>{{player.player_pp_total}}</td>
                            <td>{{player.player_pp_offensive}}</td>
                            <td>{{player.player_pp_neutral}}</td>
                            <td>{{player.player_pp_defensive}}</td>
                            <td>{{player.player_sh_total}}</td>
                            <td>{{player.player_sh_offensive}}</td>
                            <td>{{player.player_sh_neutral}}</td>
                            <td>{{player.player_sh_defensive}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  </article>
                  <article class="tile is-child box">
                  <section class="hero is-dark bold">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Hits</h1> 
                      </div>
                    </div>
                  </section>
                  <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                       Team totals<p class="subtitle">Hit Count - Average / Game</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'doughnut'" :data="hit_totals" :options="fo_total_options" style="max-width:50%;height=400px;margin:0 auto;"></chart>
                    </article>
                  </div>                    
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Total</th>
                        <th>Avg hits per game</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{this.Hits.home_total}}</td>
                          <td>{{this.Hits.average_total_home}}</td>
                        </tr>
                      </tbody>
                     </table>
                  </div>
                    <section class="hero is-light">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">
                        Player Totals <p class="subtitle">Hit Count -Avgerage / Games Played</p>
                        </h1>
                      </div>
                    </div>
                  </section>
                  <div class="tile is-parent is-6 is-vertical" style="margin:0 auto;">
                    <article class="tile is-child" style="margin:0 auto;">
                      <chart :type="'bar'" :data="hit_player_totals" :options="bar_options" style=""></chart>
                    </article>
                  </div>                   
                  <div class="block content">
                    <table class="table is-responsive">                        
                      <thead>
                        <th>Player</th>
                        <th>Hit Count</th>
                        <th>Avg / Game</th>
                      </thead>
                      <tbody>
                        <tr v-for="player in this.Hits.home_players">
                            <td>{{player.player_id}}</td>
                            <td>{{player.player_total}}</td>
                            <td>{{player.player_avg_game}}</td>
                        </tr>
                      </tbody>
                    </table>
                    </div>
                </article>
                <article class="tile is-child box">
                  <section class="hero is-dark bold">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Penalty Minutes (PIMS)</h1> 
                      </div>
                    </div>
                  </section>
                  <div class="block">

                  </div>
                </article>
                <article class="tile is-child box">
                  <section class="hero is-dark bold">
                    <div class="hero-body">
                      <div class="container">
                        <h1 class="title">Goals</h1> 
                      </div>
                    </div>
                  </section>
                  <div class="block">
                   
                  </div>
                </article>
              </div>
        </article>
     </div>
    </div>
  </div>
</template>

<style lang="scss">
.small {
  font-size: 1em;
  display: inline-block;
}
.table-responsive {
  display: block;
  width: 100%;
  min-height: 0.01%;
  overflow-x: auto;
}
.title {
  font-size: 32px;
}
.bold-el{
  font-size:26px;
  font-style: bold;
}
.select{
      font-size: 20px;
}
.is-success {
  font-size: 1.5em;
}
.is-danger {
  font-size: 1.5em;
}
.td p {
  font-size: 1.5em;
}
.player_icon {
  width: 162px;
  height: 162px;
  border-radius: 50%;
  vertical-align: middle;
}
.team_text {
  font-size: 1.5em;
  margin-left: 20px;
}
.player_info {
  font-size: 1.4em;
}
.score {
  font-size: 34px;
}
@media screen and (max-width: 600px){
     .is-canvas-responsive{
         display:none;
    }
}
 @media screen and (max-width: 800px){
     .is-responsive{
         width: 100%;
         border-collapse: collapse;
         border-spacing: 0;
         display: block;
         position: relative;
    }
     td:empty:before{
         content: '\00a0';
    }
     th, td{
         margin: 0;
         vertical-align: top;
    }
     th{
         text-align: left;
    }
     thead{
         border-right: solid 2px;
         display: block;
         float: left;
    }
     tr{
         display: block;
         padding: 0 10px 0 0;
    }
     th::before{
         content: "\00a0";
    }
     td, th{
         border-width: 0 0 1px;
    }
     tbody{
         display: block;
         width: auto;
         position: relative;
         overflow-x: auto;
         white-space: nowrap;
    }
     tr{
         display: inline-block;
         vertical-align: top;
    }
     th{
         display: block;
         text-align: right;
    }
     td{
         display: block;
         min-height: 1.25em;
         text-align: left;
    }
     th, td &:last-child{
         border-bottom-width: 0;
    }
     tr &:last-child td:not(:last-child){
         //border: $table-cell-border;
         // border-width: $table-cell-border-width;
    }
     &.is-bordered td, th{
         border-width: 1px;
    }
     tr td, th &:last-child{
         border-bottom-width: 1px;
    }
     &:last-child td, th{
         border-width: 1px;
    }     
}
</style>

<script>
import simpleheat from '../../store/modules/simpleheat/simpleheat'
// import randomColor from '../../store/modules/utils/randomColor'
import Slider from 'vue-bulma-slider'
import Chart from 'vue-bulma-chartjs'
export default {
  name: 'player',
  components: {
    Slider,
    Chart
  },
  data () {
    return {
      Faceoffs: [],
      Shots: [],
      Turnovers: [],
      Hits: [],
      Totals: [],
      showAll: true,
      Teams: [],
      teamId: 0,
      heatData: [0, 0, 0],
      gameView: true,
      selected: '0',
      options: [
        { text: 'All Shots', value: '0' },
        { text: 'On Net', value: '1' },
        { text: 'Blocked', value: '2' },
        { text: 'Missed Net', value: '3' }
      ],
      heatSize: 10,
      periodSelect: '0',
      periodOptions: [
        { text: 'All Periods', value: '0' },
        { text: 'Period 1', value: '1' },
        { text: 'Period 2', value: '2' },
        { text: 'Period 3', value: '3' },
        { text: 'Overtime', value: '4' }
      ],
      fo_total_labels: ['Won', 'Lossed'],
      so_total_labels: ['Home On Target', 'Away On Target'],
      fo_total_lane_labels: ['Left Wins', 'Center Wins', 'Right Wins'],
      fo_total_data: ['110', '120'],
      fo_total_options: {
        segmentShowStroke: false
      },
      bar_options: {
        title: {
          display: false,
          text: 'Faceoff wins by Player'
        },
        tooltips: {
          mode: 'index',
          intersect: true,
          autoSkip: false
        },
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
            maxBarThickness: 30.21,
            ticks: {
              autoSkip: false
            }
          }],
          yAxes: [{
            stacked: true,
            maxBarThickness: 30.21,
            ticks: {
              autoSkip: false
            }
          }]
        }
      },
      backgroundColor: [
        '#1fc8db',
        '#fce473',
        '#42afe3',
        '#ed6c63',
        '#97cd76'
      ],
      isFaceoffsPvp: false,
      isFaceoffOpen: true
    }
  },
  computed: {
    fo_total_chart () {
      return {
        labels: this.fo_total_labels,
        datasets: [{
          data: this.getFoChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      }
    },
    fo_total_lane_chart () {
      return {
        labels: this.fo_total_lane_labels,
        datasets: [{
          data: this.getFoLaneChartTotals(),
          backgroundColor: this.backgroundColor
        }]
      }
    },
    fo_player_series () {
      let playerLabels = []
      for (var label of this.Faceoffs.players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerWins = []
      let playerLosses = []
      for (var wins of this.Faceoffs.players) {
        playerWins.push(wins.player_fow)
      }
      for (var losses of this.Faceoffs.players) {
        playerLosses.push(losses.player_fol)
      }
      data.datasets = [{
        data: playerWins,
        label: 'Wins',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerLosses,
        label: 'Losses',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    fo_player_lane () {
      let playerLabels = []
      for (var label of this.Faceoffs.players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerLeftWins = []
      let playerCenterWins = []
      let playerRightWins = []
      for (var leftWins of this.Faceoffs.players) {
        playerLeftWins.push(leftWins.player_lane_left_wins)
      }
      for (var centerWins of this.Faceoffs.players) {
        playerCenterWins.push(centerWins.player_lane_center_wins)
      }
      for (var rightWins of this.Faceoffs.players) {
        playerRightWins.push(rightWins.player_lane_right_wins)
      }
      data.datasets = [{
        data: playerLeftWins,
        label: 'Left Wins',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerCenterWins,
        label: 'Center Wins',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerRightWins,
        label: 'Right Wins',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    fo_player_zone () {
      let playerLabels = []
      for (var label of this.Faceoffs.players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerOffensiveWins = []
      let playerNeutralWins = []
      let playerDefensiveWins = []
      for (var offensiveWins of this.Faceoffs.players) {
        playerOffensiveWins.push(offensiveWins.player_zone_offensive_wins)
      }
      for (var neutralWins of this.Faceoffs.players) {
        playerNeutralWins.push(neutralWins.player_zone_neutral_wins)
      }
      for (var defensiveWins of this.Faceoffs.players) {
        playerDefensiveWins.push(defensiveWins.player_zone_defensive_wins)
      }
      data.datasets = [{
        data: playerOffensiveWins,
        label: 'Offensive Wins',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerNeutralWins,
        label: 'Neutral Wins',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerDefensiveWins,
        label: 'Defensive Wins',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    fo_player_situation () {
      let playerLabels = []
      for (var label of this.Faceoffs.players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerWinsEH = []
      let playWinsPP = []
      let playerWinsSH = []
      for (var eh of this.Faceoffs.players) {
        playerWinsEH.push(eh.player_situation_eh_wins)
      }
      for (var pp of this.Faceoffs.players) {
        playWinsPP.push(pp.player_situation_pp_wins)
      }
      for (var sh of this.Faceoffs.players) {
        playerWinsSH.push(sh.player_situation_sh_wins)
      }
      data.datasets = [{
        data: playerWinsEH,
        label: 'Even Handed Wins',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playWinsPP,
        label: 'Power Play Wins',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerWinsSH,
        label: 'Short Handed Wins',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    so_total_chart () {
      return {
        labels: this.so_total_labels,
        datasets: [{
          data: this.getSoTotals(),
          backgroundColor: this.backgroundColor
        }]
      }
    },
    shot_player_totals () {
      let playerLabels2 = []
      for (var label of this.Shots.home_players) {
        playerLabels2.push(label.player_id)
      }
      let data = {
        labels: playerLabels2
      }
      data.datsets = []
      let playerOnNet = []
      let playerMissedNet = []
      let playerBlocked = []
      for (var onNet of this.Shots.home_players) {
        playerOnNet.push(onNet.player_on_net)
      }
      for (var missedNet of this.Shots.home_players) {
        playerMissedNet.push(missedNet.player_missed_net)
      }
      for (var blocked of this.Shots.home_players) {
        playerBlocked.push(blocked.player_blocked)
      }
      data.datasets = [{
        data: playerOnNet,
        label: 'On Net',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerOnNet,
        label: 'Missed Net',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerBlocked,
        label: 'Blocked',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      console.log('DATA is: ' + data.datasets)
      return data
    },
    shot_away_player_totals () {
      let playerLabels = []
      for (var label of this.Shots.away_players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerOnNet = []
      let playerMissedNet = []
      let playerBlocked = []
      for (var onNet of this.Shots.away_players) {
        playerOnNet.push(onNet.player_on_net)
      }
      for (var missedNet of this.Shots.away_players) {
        playerMissedNet.push(missedNet.player_missed_net)
      }
      for (var blocked of this.Shots.away_players) {
        playerBlocked.push(blocked.player_blocked)
      }
      data.datasets = [{
        data: playerOnNet,
        label: 'On Net',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerMissedNet,
        label: 'Missed Net',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerBlocked,
        label: 'Blocked',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    shot_player_situational () {
      let playerLabels = []
      for (var label of this.Shots.home_players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerPPOnNet = []
      let playerSHOnNet = []
      for (var onNetPP of this.Shots.home_players) {
        playerPPOnNet.push(onNetPP.player_pp_on_net)
      }
      for (var onNetSH of this.Shots.home_players) {
        playerSHOnNet.push(onNetSH.player_sh_on_net)
      }
      data.datasets = [{
        data: playerPPOnNet,
        label: 'PP On Net',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerSHOnNet,
        label: 'SH On Net',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    shot_away_player_situational () {
      let playerLabels = []
      for (var label of this.Shots.away_players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerPPOnNet = []
      let playerSHOnNet = []
      for (var onNetPP of this.Shots.away_players) {
        playerPPOnNet.push(onNetPP.player_pp_on_net)
      }
      for (var onNetSH of this.Shots.away_players) {
        playerSHOnNet.push(onNetSH.player_sh_on_net)
      }
      data.datasets = [{
        data: playerPPOnNet,
        label: 'PP On Net',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerSHOnNet,
        label: 'SH On Net',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      }]
      return data
    },
    to_totals () {
      let labels = ['Offensvie', 'Neutral', 'Defensive']
      let data = [parseInt(this.Turnovers.home_total_offensive), parseInt(this.Turnovers.home_total_neutral), parseInt(this.Turnovers.home_total_defensive)]
      return {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: this.backgroundColor
        }]
      }
    },
    to_player_totals () {
      let playerLabels = []
      for (var label of this.Turnovers.home_players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerOffensive = []
      let playerNeutral = []
      let playerDefensive = []
      for (var offensive of this.Turnovers.home_players) {
        playerOffensive.push(offensive.player_offensive)
      }
      for (var neutral of this.Turnovers.home_players) {
        playerNeutral.push(neutral.player_neutral)
      }
      for (var defensive of this.Turnovers.home_players) {
        playerDefensive.push(defensive.player_defensive)
      }
      data.datasets = [{
        data: playerOffensive,
        label: 'Offensive',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerNeutral,
        label: 'Neutral',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerDefensive,
        label: 'Defensive',
        backgroundColor: 'rgba(255, 206, 86, 0.4)',
        borderColor: 'rgba(255, 206, 86, 1)'
      }]
      return data
    },
    to_player_situational () {
      let playerLabels = []
      for (var label of this.Turnovers.home_players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerOffensivePP = []
      let playerNeutralPP = []
      let playerDefensivePP = []
      let playerOffensiveSH = []
      let playerNeutralSH = []
      let playerDefensiveSH = []
      for (var offensivePP of this.Turnovers.home_players) {
        playerOffensivePP.push(offensivePP.player_pp_offensive)
      }
      for (var neutralPP of this.Turnovers.home_players) {
        playerNeutralPP.push(neutralPP.player_pp_neutral)
      }
      for (var defensivePP of this.Turnovers.home_players) {
        playerDefensivePP.push(defensivePP.player_pp_defensive)
      }
      for (var offensiveSH of this.Turnovers.home_players) {
        playerOffensiveSH.push(offensiveSH.player_sh_offensive)
      }
      for (var neutralSH of this.Turnovers.home_players) {
        playerNeutralSH.push(neutralSH.player_sh_neutral)
      }
      for (var defensiveSH of this.Turnovers.home_players) {
        playerDefensiveSH.push(defensiveSH.player_sh_defensive)
      }
      data.datasets = [{
        data: playerOffensivePP,
        label: 'Offensive PP',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      },
      {
        data: playerNeutralPP,
        label: 'Neutral PP',
        backgroundColor: 'rgba(7, 144, 237, 0.4)',
        borderColor: 'rgba(7, 144, 237, 1)'
      },
      {
        data: playerDefensivePP,
        label: 'Defensive PP',
        backgroundColor: 'rgba(0, 112, 188, 0.4)',
        borderColor: 'rgba(0, 112, 188, 1)'
      },
      {
        data: playerOffensiveSH,
        label: 'Offensive SH',
        backgroundColor: 'rgba(255, 99, 132, 0.4)',
        borderColor: 'rgba(255, 99, 132, 1)'
      },
      {
        data: playerNeutralSH,
        label: 'Neutral SH',
        backgroundColor: 'rgba(193, 31, 65, 0.4)',
        borderColor: 'rgba(193, 31, 65, 1)'
      },
      {
        data: playerDefensiveSH,
        label: 'Defensive SH',
        backgroundColor: 'rgba(170, 1, 37, 0.4)',
        borderColor: 'rgba(170, 1, 37, 1)'
      }]
      return data
    },
    hit_totals () {
      let labels = ['Hits']
      let data = [this.Hits.home_total]
      return {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: this.backgroundColor
        }]
      }
    },
    hit_player_totals () {
      let playerLabels = []
      for (var label of this.Hits.home_players) {
        playerLabels.push(label.player_id)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      let playerHits = []
      for (var hits of this.Hits.home_players) {
        playerHits.push(hits.player_total)
      }
      data.datasets = [{
        data: playerHits,
        label: 'Hits',
        backgroundColor: 'rgba(54, 162, 235, 0.4)',
        borderColor: 'rgba(54, 162, 235, 1)'
      }]
      return data
    }
  },
  methods: {
    fetchTeams () {
      console.log('Get query')
      this.$http
        .get('https://devilsapi.roblutken.com/api/teams/get', {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            console.log('Fixture Data is ' + response.data)
            this.Teams = response.data
          // console.log(this.Teams[0])
          },
          response => {}
        )
    },
    fetchShotTotals () {
      console.log('Get Shots totals')
      this.teamId = this.$route.params.teamId
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/shots/season/get/' + this.teamId,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            // console.log('Shot Data is ' + response.data)
            this.Shots = response.data
           // console.log(JSON.stringify(this.Shots))
          },
          response => {}
        )
    },
    fetchTurnoverTotals () {
      console.log('Get Turnover totals')
      this.teamId = this.$route.params.teamId
      this.$http.get('https://devilsapi.roblutken.com/api/turnovers/season/get/' +
            this.teamId,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            // console.log('Shot Data is ' + response.data)
            this.Turnovers = response.data
            // console.log(JSON.stringify(this.Turnovers))
          },
          response => {}
        )
    },
    fetchHitTotals () {
      console.log('Get Hit totals')
      this.teamId = this.$route.params.teamId
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/hits/season/get/' + this.teamId,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            // console.log('Hits Data is ' + response.data)
            this.Hits = response.data
            // console.log(JSON.stringify(this.Hits))
          },
          response => {}
        )
    },
    fetchFaceoffTotals () {
      console.log('Get faceoff totals')
      this.teamId = this.$route.params.teamId
      this.$http
        .get(
          'https://devilsapi.roblutken.com/api/faceoffs/season/get/' +
            this.teamId,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            // console.log('Faceoff Data is ' + response.data)
            this.Faceoffs = response.data
            // console.log(JSON.stringify(this.Faceoffs.players.player_vs_player))
          },
          response => {}
        )
    },
    fetchShotHeatmap (shotType, period) {
      this.$http.get(
          'https://devilsapi.roblutken.com/api/shots/heatmap/get?id=' + this.teamId + '&teamSelect=' + 14 +
          '&shotType=' + shotType + '&period=' + period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
      .then(response => {
        // console.log('Response was: ' + JSON.stringify(response.data))
        var shots = JSON.parse(JSON.stringify(response.data))
        setTimeout(() => {
          var canvas = this.$refs.home_shots_canvas
          var heat = simpleheat(canvas).data(shots['shot_locations'])
          heat.radius(this.heatSize, 30)
          heat.draw()
        }, 3048)
      })
      this.$http.get(
          'https://devilsapi.roblutken.com/api/shots/heatmap/get?id=' + this.teamId + '&teamSelect=' + this.teamId +
           '&shotType=' + shotType + '&period=' + period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
      .then(response => {
        // console.log('Response was: ' + response.data)
        var shots = JSON.parse(JSON.stringify(response.data))
        setTimeout(() => {
          var canvas = this.$refs.away_shots_canvas
          var heat = simpleheat(canvas).data(shots['shot_locations'])
          heat.radius(this.heatSize, 30)
          heat.draw()
        }, 3048)
      })
      this.$http.get(
          'https://devilsapi.roblutken.com/api/shots/heatmap/get/powerplay?id=' + this.teamId + '&teamSelect=' + 14 +
          '&shotType=' + shotType + '&period=' + period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
      .then(response => {
        // console.log('Response was: ' + response.data)
        var shots = JSON.parse(JSON.stringify(response.data))
        setTimeout(() => {
          var canvas = this.$refs.home_shots_canvas_pp
          var heat = simpleheat(canvas).data(shots['shot_locations'])
          heat.radius(this.heatSize, 30)
          heat.draw()
        }, 3048)
      })
      this.$http.get(
          'https://devilsapi.roblutken.com/api/shots/heatmap/get/powerplay?id=' + this.teamId + '&teamSelect=' +
          this.teamId + '&shotType=' + shotType + '&period=' + period,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
      .then(response => {
        // console.log('Response was: ' + response.data)
        var shots = JSON.parse(JSON.stringify(response.data))
        setTimeout(() => {
          var canvas = this.$refs.away_shots_canvas_pp
          var heat = simpleheat(canvas).data(shots['shot_locations'])
          heat.radius(this.heatSize, 30)
          heat.draw()
        }, 3048)
      })
    },
    updateHeatmaps () {
      console.log('Updating heatmaps' + this.selected + 'Period: ' + this.periodSelect)
      this.fetchShotHeatmap(this.selected, this.periodSelect)
    },
    updateHeatmapSize (val) {
      this.heatSize = val
      this.updateHeatmaps()
    },
    getFoChartTotals () {
      let foData = [this.Faceoffs.total_wins, this.Faceoffs.total_losses]
      return foData
    },
    getFoLaneChartTotals () {
      let foData = [this.Faceoffs.wins_left, this.Faceoffs.wins_center, this.Faceoffs.wins_right]
      return foData
    },
    getSoTotals () {
      let soData = [parseInt(this.Shots.home_total_on_net), parseInt(this.Shots.away_total_on_net)]
      return soData
    },
    getRandomColor () {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    toggleFaceoffs: function () {
      this.isFaceoffOpen = !this.isFaceoffOpen
    },
    toggleFaceoffsPvp: function () {
      this.isFaceoffsPvp = !this.isFaceoffsPvp
    }
  },
  created: function () {
    console.log(this.$route.params.teamId)
    this.fetchShotTotals()
    this.fetchFaceoffTotals()
    this.fetchTurnoverTotals()
    this.fetchHitTotals()
  },
  updated: function () {
  },
  mounted: function () {
    this.fetchShotHeatmap(0, 0)
  }
}
</script>



// WEBPACK FOOTER //
// team-stats.vue?bbb6c250